import axios from "axios";
import { toastErro, toastInformacao } from "../components/Toast";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Content-Type"] = 'application/json';

const api = axios.create({
  baseURL : "http://localhost:80010",
});

api.interceptors.request.use( function (config) {
  const token = localStorage.getItem('token');
  config.headers.Authorization =  token ? `Bearer ${token}` : '';

  return config;
});

api.interceptors.response.use(
  function (response){
    return response;
  }, function (err) {
    if(err.response?.status === 401) {
      toastErro('Login Expirado.')
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      window.location.href = '/';
    }     
    else {
      toastErro('Ocorreu um erro inesperado Tente Novamente ou entre em Contato com Administrador')
      console.log(err?.response?.data)
      return Promise.reject(err);
    }
  }
);

export { api };